import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { CloseButton } from '../CloseButton';
import { useDetailPanelSafe } from './DetailPanelContext';
import { ChevronLeftIcon } from '../icons';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './detailPanel.styles';

type DetailPanelHeaderProps = {
  onClose: () => void;
  actions?: ReactNode;
  closeLabel?: string;
};

export const DetailPanelHeader = ({ onClose, actions, closeLabel }: DetailPanelHeaderProps) => {
  const panelContext = useDetailPanelSafe();
  const configTitle = (panelContext?.panelConfig as { title?: string } | undefined)?.title;
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const propertyName =
    configTitle ||
    (listing as unknown as { propertyName?: string })?.propertyName ||
    (listing as unknown as { displayName?: string })?.displayName ||
    listing?.address?.street ||
    '';

  return (
    <header className={styles.panelHeader}>
      <div className={styles.panelHeaderColumns}>
        <div className={styles.panelHeaderLeft}>
          {closeLabel ? (
            <button className={styles.panelBackButton} onClick={onClose} aria-label={closeLabel}>
              <ChevronLeftIcon />
              <span>{closeLabel}</span>
            </button>
          ) : (
            <CloseButton onClick={onClose} aria-label="Close panel" size="sm" />
          )}
          <h2 className={styles.panelHeaderTitle}>{propertyName}</h2>
        </div>
        <div className={styles.panelHeaderRight}>{actions}</div>
      </div>
    </header>
  );
};
